import { FC } from 'react'
import styled from 'styled-components'
import { getImageSrc } from 'utils/screen'
import { ImageThumbnail40Fragment } from 'api/operations'
import CompanyStatusIcon, {
  CompanyVerificationStatus,
} from 'components/Common/CompanyStatusIcon'

const Avatar = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  position: relative;
`

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-position: center;
  object-fit: contain;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.16);
`

const TopRightBadge = styled.div`
  position: absolute;
  top: -3px;
  right: -3px;
`

interface CompanyAvatarProps {
  avatar?: ImageThumbnail40Fragment | null
  status?: string
}

const CompanyAvatar: FC<CompanyAvatarProps> = ({ avatar, status }) => {
  return (
    <Avatar>
      {avatar?.thumbnailUrl ? (
        <Image alt='company avatar' {...getImageSrc(avatar)} />
      ) : (
        <NoAvatarImage />
      )}

      {status && (
        <TopRightBadge>
          <CompanyStatusIcon status={status as CompanyVerificationStatus} />
        </TopRightBadge>
      )}
    </Avatar>
  )
}

// prettier-ignore
const NoAvatarImage = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='40' height='40' fill='none' viewBox='0 0 40 40'>
    <rect width='40' height='40' fill='#E7E7EA' rx='4' />
    <path fill='#A0A1AD' fillRule='evenodd'
          d='M28 14h-4v-2a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2h-4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V16a2 2 0 0 0-2-2Zm-10-2h4v2h-4v-2Z'
          clipRule='evenodd' />
    <rect width='39' height='39' x='.5' y='.5' stroke='#fff' strokeOpacity='.2' rx='3.5' />
  </svg>
)

export default CompanyAvatar
